import React from "react";
import { StatCard } from "@/components/ui";
import { useDerivedCustomerStats } from "@/hooks/useGlobalStats";

export const CustomersStats = ({ leads = [], onFilterUnassigned, user }) => {
  const role = user?.role?.toLowerCase()?.trim() || "";
  const isAdmin = ["admin", "owner", "Verve-admin", "systemadmin"].includes(role);
  const isTelecaller = ["telecaller", "telecalling"].includes(role);
  const isOwner = role === "owner";
  const showConversion = !isOwner;

  const {
    ContactsCount,
    teleconvertedCount,
    teleinterestedCount,
    teleappointedCount,
    telereferralsCount,
    teleunassignedCount,
    telediscussionCount,
    teleconversionRate,
  } = useDerivedCustomerStats(leads);

  // Count unique locations from the same data powering the table
  const uniqueLocationsCount = new Set(
    leads.map(l => (l.city || "").trim().toLowerCase()).filter(Boolean)
  ).size;

  return (
    <div className="space-y-4 relative group/stats">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 auto-rows-fr">

        {/* Total Contacts */}
        <StatCard
          variant="luxury"
          title={isTelecaller ? "Total Assigned" : "Total Contacts"}
          value={ContactsCount}
          sub="Total contacts in database"
          topColor="border-t-[#5d6b8b]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>}
        />

        {/* Locations */}
        <StatCard
          variant="luxury"
          title="Locations"
          value={uniqueLocationsCount}
          sub="Unique cities in contacts"
          topColor="border-t-[#5d6b8b]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>}
        />

        {/* Converted */}
        <StatCard
          variant="luxury"
          title="Converted"
          value={teleconvertedCount}
          sub="Converted Contacts"
          topColor="border-t-[#5d6b8b]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>}
        />

        {/* Conversion Rate */}
        {showConversion && (
          <StatCard
            variant="luxury"
            title="Conversion"
            value={`${teleconversionRate}%`}
            sub="Overall conversion rate"
            topColor="border-t-[#5d6b8b]"
            iconHoverColor="group-hover:text-[#ffa000]"
            illustration={<svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>}
          />
        )}

        {/* Unassigned (Admin only) */}
        {isAdmin && (
          <StatCard
            variant="luxury"
            title="Discussion In Progress"
            value={telediscussionCount}
            sub="Active discussions"
            onClick={onFilterUnassigned}
            className="cursor-pointer"
            topColor="border-t-[#5d6b8b]"
            iconHoverColor="group-hover:text-[#ffa000]"
            illustration={<svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>}
          />
        )}
      </div>
    </div>
  );
};
